import React from 'react'
import ListSpecimen from './ListSpecimen/ListSpecimen'
import ListUnits from './ListUnits/ListUnits'
import CategoryIndex from './CategoryIndex/CategoryIndex'
import ListIndicators from './ListIndicators/ListIndicators'

const ListConfiguration = () => {
  return (
    <div className="Configuration">
      <ListSpecimen></ListSpecimen>
      <ListUnits></ListUnits>
      {/* <GroupAnalysis></GroupAnalysis>
      <CategoryAnalysis></CategoryAnalysis> */}
      <CategoryIndex></CategoryIndex>
      <ListIndicators></ListIndicators>
    </div>
  )
}

export default ListConfiguration